import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const fetchInquirer = () => {
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.users.byRole, { role: [6,7] })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
